module.exports = __webpack_public_path__ + "img/test-start-button.b7e6caf7.png";